import { render, staticRenderFns } from "./BackgroundTasks.vue?vue&type=template&id=1d4f3fdc&scoped=true"
import script from "./BackgroundTasks.vue?vue&type=script&lang=js"
export * from "./BackgroundTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f3fdc",
  null
  
)

export default component.exports